export default "__VITE_ASSET__T_JRVAkF__"